import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ArrowLeft } from "lucide-react";
import { ArticleForm } from "@/components/admin/ArticleForm";

export const Route = createFileRoute("/_authenticated/admin/blog/$id")({
  head: () => ({ meta: [{ title: "Editar artículo — Admin" }] }),
  component: EditArticle,
});

function EditArticle() {
  const { id } = Route.useParams();
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "article", id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("articles")
        .select("*")
        .eq("id", id)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
  });

  return (
    <div>
      <Link
        to="/admin/blog"
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4" /> Volver al blog
      </Link>
      <h1 className="mt-3 text-2xl font-semibold text-foreground">Editar artículo</h1>
      <div className="mt-6">
        {isLoading ? (
          <div className="h-64 animate-pulse rounded-xl bg-secondary/60" />
        ) : !data ? (
          <p className="text-sm text-muted-foreground">Artículo no encontrado.</p>
        ) : (
          <ArticleForm initial={data} />
        )}
      </div>
    </div>
  );
}
